import PropTypes from "prop-types"
import React from "react"
import styles from "./styles.scss"

const Spinner = ({ enabled = true, title = "Loading" }) => {
  if (enabled) {
    return <span role="status" aria-busy={true} className={styles.loader} title={title} />
  }
  return null
}

Spinner.propTypes = {
  enabled: PropTypes.bool,
  title: PropTypes.string,
}

export default Spinner
